import { not, isNil, isEmpty } from 'ramda'

export const isNotNil = value => not(isNil(value))
export const isNotEmpty = value => not(isEmpty(value))
export const isNotNilOrEmpty = value => isNotNil(value) && isNotEmpty(value)
export const isNilOrEmpty = value => isNil(value) || isEmpty(value)
